export const ACTOR_LIFELINE_Y = 90;

export const ORIGIN_ANGLE = 0;

export const COMPLETE_ANGLE = Math.PI * 2;

/**
 * The initial X coordinate for drawing the actor.
 * This serves as a central horizontal reference point around which the actor is drawn.
 * @constant {number}
 * @default 50
 */
export const BEGIN_ACTOR = 50;

/**
 * The radius of the actor's head.
 * Acts as the base unit for calculating the size and placement of all other actor body parts.
 * @constant {number}
 * @default 15
 */
export const HEAD_RADIUS = 15;

/**
 * The height of the actor's body (excluding the head).
 * Set to twice the head radius to maintain consistent proportions.
 * @constant {number}
 */
export const BODY_HEIGHT = HEAD_RADIUS * 2;

/**
 * Vertical offset to position the head above the body.
 * A negative value to lift the head placement above the origin point.
 * @constant {number}
 */
export const HEAD_PLACEMENT = -HEAD_RADIUS * 1.5;

/**
 * The total horizontal span of the arms.
 * Calculated to be wider than the head/body to represent extended arms.
 * @constant {number}
 */
export const ARMS_LENGTH = HEAD_RADIUS * 4;

/**
 * The X coordinate where the arms begin (left side).
 * Centered horizontally around `BEGIN_ACTOR` based on `ARMS_LENGTH`.
 * @constant {number}
 */
export const BEGIN_ARMS = BEGIN_ACTOR - ARMS_LENGTH / 2;

/**
 * The vertical Y coordinate where the legs end.
 * Helps define how far the legs extend below the body.
 * @constant {number}
 */
export const END_LEGS_Y = HEAD_RADIUS * 3.5;

/**
 * The X coordinate of the endpoint of the left leg.
 * Positioned relative to the arms to maintain body alignment.
 * @constant {number}
 */
export const END_LEFT_LEG_X = BEGIN_ARMS + HEAD_RADIUS;

/**
 * The X coordinate of the endpoint of the right leg.
 * Positioned relative to the arms to match the symmetrical leg spacing.
 * @constant {number}
 */
export const END_RIGHT_LEG_X = BEGIN_ARMS + HEAD_RADIUS * 3;

/**
 * The vertical offset from the top of the body to place the arms.
 * Slightly below the head for anatomically logical placement.
 * @constant {number}
 */
export const ARMS_PLACEMENT = HEAD_RADIUS / 2;

/**
 * The Y coordinate to position the actor’s label below the figure.
 * Set below the end of the legs, with spacing based on `HEAD_RADIUS`.
 * @constant {number}
 */
export const ACTOR_LABEL_PLACEMENT = END_LEGS_Y + HEAD_RADIUS;
